import { styled } from '@mui/material';

// Optionally wrap the paginator with div
export const PaginationContainer = styled('div')`
    display: flex;
    justify-content: flex-end;
`;
